import { render, staticRenderFns } from "./open-live.vue?vue&type=template&id=fb037150&scoped=true&"
import script from "./open-live.vue?vue&type=script&lang=js&"
export * from "./open-live.vue?vue&type=script&lang=js&"
import style0 from "./open-live.vue?vue&type=style&index=0&id=fb037150&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb037150",
  null
  
)

export default component.exports